import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import saccoWithdrawalService from "@saccoWithdrawalService";

/**
 * Hook to record a SACCO withdrawal and atomically credit the target account.
 * Calls create_sacco_withdrawal_with_credit RPC which handles currency conversion server-side.
 * On success: invalidates ['sacco_withdrawals', membershipId], ['transactions'], and ['accounts'].
 */
export default function useCreateSaccoWithdrawalWithCredit() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (input: SaccoWithdrawalWithCreditRequest) => {
      if (!user) throw new Error('User not authenticated');

      return await saccoWithdrawalService.createWithCredit(user.id, input);
    },
    onSuccess: (_data, input) => {
      queryClient.invalidateQueries({ queryKey: ['sacco_withdrawals', input.membershipId] });
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
      queryClient.invalidateQueries({ queryKey: ['accounts'] });
    },
    onError: (error: Error) => {
      console.error('Sacco withdrawal creation failed:', error);
    },
  });
}
